import useBackend from '@/hooks/useBackend'
import useBasket from '@/hooks/useBasket'
import useError from '@/hooks/useError'
import usePerson from '@/hooks/usePerson'

import config from '@/config'

import { isRequired } from '@/utils/CustomErrors'
import { DateTimeUtil } from '@/utils/DateTime'

const { setup, doGet } = useBackend()
const { basket } = useBasket()
const { createErrorResponse } = useError()
const { getPersonsByMutability } = usePerson()

setup('/ovpv3/public', config.microserviceBaseUrl, {
  responseSuccess: response => {
    return response.data
  },
  responseError: error => {
    return createErrorResponse(error)
  },
})

export default function useCancellation() {
  function createPreInsurerVvg(personId, cancellationExisting = false) {
    const personVvgContractStartDate = basket.persons.find(person => person.personId === personId).vvgContractStartDate
    return {
      cancellationExisting,
      preInsurerId: null,
      cancellationDate: DateTimeUtil.getDayBefore(personVvgContractStartDate),
      preInsurerCustomerNumber: null,
      cancelAllProducts: null,
      products: null,
    }
  }

  function _getCancellationQuestions({ basketId = isRequired('basketId') }) {
    return doGet(`/baskets/${basketId}/cancellationQuestions`, {
      basketId,
    }).then(response => response.data.cancellationQuestions)
  }

  function hasEmptyPreInsurer(personPreInsurerVvgs) {
    const noPreInsurerVvg = !personPreInsurerVvgs.length
    const hasSingleEmptyPreInsurerVvg = hasSingleEmptyPreInsurer(personPreInsurerVvgs)
    return noPreInsurerVvg || hasSingleEmptyPreInsurerVvg
  }

  function hasSingleEmptyPreInsurer(personPreInsurerVvgs) {
    return personPreInsurerVvgs.length === 1 && personPreInsurerVvgs.every(p => p.cancellationExisting === false)
  }

  function filterPersonsWithCancellation(personsWithCancellationQuestions) {
    const { mutable: mutablePersons } = getPersonsByMutability(basket.persons)
    return mutablePersons.filter(mutablePerson =>
      personsWithCancellationQuestions.find(p => p.personId === mutablePerson.personId)
    )
  }

  function loadCancellationQuestions(basketId) {
    return _getCancellationQuestions({ basketId })
  }

  return {
    createPreInsurerVvg,
    filterPersonsWithCancellation,
    hasEmptyPreInsurer,
    hasSingleEmptyPreInsurer,
    loadCancellationQuestions,
  }
}
